import { Component, h } from 'preact';
import { noOp, Properties, WidgetTab } from '../../common';
import { Actions, actions, connectStore } from '../../store';
import { withStyles, WithStyles } from '../../style';
import AmNotification from './AmNotification/AmNotification';
import DestinationNotification from './DestinationNotification/DestinationNotification';
import NoFlightsNotification from './NoFlightsNotification/NoFlightsNotification';
import RouteNotSupportedNotification from './RouteNotSupportedNotification/RouteNotSupportedNotification';
import SeasonalNotification from './SeasonalNotification/SeasonalNotification';
import { KuusamoNotification } from './KuusamoNotification/KuusamoNotification';
import BusConnectionNotification from './BusConnectionNotification/BusConnectionNotification';

interface InputProps {
  currentTab: WidgetTab;
}

type EffectiveProps = Properties & Actions & WithStyles & InputProps;

@withStyles()
@connectStore({ mapStateToProps: noOp, actions })
export default class Notifications extends Component<Properties & InputProps> {
  logNotificationExpand = (notification: string, expanded: boolean): void => {
    (this.props as EffectiveProps).logGtmUiEvent({
      id: 'expandNotification',
      state: `${notification}-expanded: ${expanded}`,
    });
  };

  render({ tx, currentTab }: EffectiveProps): h.JSX.Element {
    return (
      <div class={tx(this.props.class)}>
        {currentTab === WidgetTab.AWARD && <RouteNotSupportedNotification />}
        <NoFlightsNotification data-test-no-flights-notification />
        <BusConnectionNotification data-test-bus-connection-notification />
        <SeasonalNotification data-test-seasonal-notification />
        <DestinationNotification data-test-destination-notification />
        {currentTab === WidgetTab.AM && (
          <AmNotification onExpand={this.logNotificationExpand} data-test-am-notification />
        )}
        <KuusamoNotification />
      </div>
    );
  }
}
